export interface Link {
    id: number;
    code: string;
    name: string;
    showInStats: boolean;
    disallowRefilling?: boolean;
    editing: boolean;
    values: Array<string>;
    params: Record<string, any>;
}

export const initialLink: Readonly<Link> = {
    editing: false,
    id: 0,
    code: '',
    name: '',
    showInStats: false,
    values: [],
    params: {},
};
